import { Moment } from "moment-timezone";
import React from "react";
import DateHeaderCell from "./DateHeaderCell";

type DateHeaderContainerProps = {
  datesList: { date: Moment; isDisabled: boolean }[];
  onSelectDay?: (date: Moment) => void;
  selectedDate?: Moment | null;
};
export default function DateHeaderContainer(props: DateHeaderContainerProps) {
  const { datesList, onSelectDay, selectedDate } = props;

  return (
    <div className="grid grid-cols-7 gap-2">
      {React.Children.toArray(
        datesList.map(({ date, isDisabled }) => (
          <DateHeaderCell
            date={date}
            isSelected={date.isSame(selectedDate, "day")}
            isDisabled={isDisabled}
            onSelectDay={onSelectDay}
          />
        ))
      )}
    </div>
  );
}
